module.exports = fox._r("images/faq-icon-email.png", __webpack_public_path__ + "images/faq-icon-email.png");


//////////////////
// WEBPACK FOOTER
// ./images/faq-icon-email.png
// module id = 11
// module chunks = 2